import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { GeoJSONLayer } from 'react-mapbox-gl';
import { CoordinatesExact } from '../../models/Coordinates';
import { hexToRgba } from '../../../common/formatters/colorFormatter';

const RightOfWay = ({ index, coordinatesArray, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: visible ? [coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude])] : [],
      },
    }),
    [visible, coordinatesArray]
  );

  return (
    <GeoJSONLayer
      id={`rightOfWay${index}`}
      data={sourceData}
      fillPaint={{
        'fill-color': hexToRgba(theme.palette.map.rightOfWay, 0.4),
        'fill-outline-color': theme.palette.map.rightOfWay,
      }}
    />
  );
};

RightOfWay.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  index: PropTypes.number,
  visible: PropTypes.bool,
};

RightOfWay.defaultProps = {
  coordinatesArray: [],
  index: 0,
  visible: true,
};

export default React.memo(RightOfWay);
